import React from "react";
import Chart from "react-google-charts";

class DoughnutChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartReference = React.createRef();


  }
  componentDidMount() {
    console.log(this.chartReference); // returns a Chart.js instance reference
  }
  render() {
    return (
      <React.Fragment>
        <div className="pie-header">
          <div className="datos">
            {this.props.dataDoughnut.datag.filter(value => value[0] != "Task" ).map((dn,index) => (
              <div key={index} className={dn[0].replace(" " , "_")}>
                <p>{dn[0]}</p>
                <p>{dn[1]}</p>
              </div>
            )
            )}

          </div>
        </div>
        <div>
          <Chart
            width={'100%'}
            height={'300px'}
            chartType="PieChart"
            loader={<div>Loading Chart</div>}

            data={
              this.props.dataDoughnut.datag
            }
            options={{
              legend: 'none',
              title: 'DISTRIBUCIÓN DE EVENTOS',
              colors: this.props.dataDoughnut.labels,
              // Just add this option
              pieHole: 0.4,
            }}
            rootProps={{ 'data-testid': '3' }}
          />
        </div>

      </React.Fragment>
    );
  }
}

export default DoughnutChart;
